/**
 * Build Voluum lander click URL from preferred tracking domain (host or path).
 * For Media Devoted | Created By Ciro Autiero
 */

export function buildLanderClickUrl(preferredDomain: string): string {
  const raw = preferredDomain.trim();
  if (!raw) return '';
  const host = raw
    .replace(/^https?:\/\//i, '')
    .split('/')[0]
    ?.trim();
  if (!host) return '';
  return `https://${host}/click`;
}
